import styled from "styled-components";

export const InputBoxWrapper = styled.div`
  & > input {
    all: unset;
    -webkit-appearance: none;
    width: 72px;
    height: 72px;
    background-color: #f5f5f5;
    font-family: inherit;
    border-radius: 5px;
    text-align: center;
    margin-right: 8px;
  }
`;
